/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeAppPassword.defs'
export { main as default } from './revokeAppPassword.defs'
